import { RecordDataSource } from "../../records/grids";
import { ColDef } from "../../records/grids/columns/colDef";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../records/grids/columns/columnDefinitionService";
import {
  ColumnDefinitionSetServiceProvider,
  vsProviderName as ColumnDefinitionSetServiceProviderName,
} from "../../records/grids/columns/columnDefinitionSetService";
import {
  GridSettingsService,
  vsName as GridSettingsServiceName,
} from "../../records/grids/settings/gridSettingsService";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../records/server/serverUtility";
import {
  RecordGridViewServiceProvider,
  vsProviderName as RecordGridViewServiceProviderName,
} from "../../records/views/recordGridView";

export const vsObjectName = "permission";

permissionObjectConfig.$inject = [
  RecordGridViewServiceProviderName,
  ColumnDefinitionSetServiceProviderName,
];
export function permissionObjectConfig(
  recordGridViewServiceProvider: RecordGridViewServiceProvider,
  columnDefinitionSetServiceProvider: ColumnDefinitionSetServiceProvider
) {
  columnDefinitionSetServiceProvider.addColumnDefinitionSet(vsObjectName, [
    ColumnDefinitionServiceName,
    (columnDefinitionService: ColumnDefinitionService): ColDef[] => {
      return [
        columnDefinitionService.getStringColDef({
          field: "PermissionName",
          header: "Permission Name",
        }),
        columnDefinitionService.getStringColDef({
          field: "Description",
          header: "Permission Description",
        }),
      ];
    },
  ]);

  recordGridViewServiceProvider.addGridConfiguration(vsObjectName, [
    ServerUtilityName,
    GridSettingsServiceName,
    (
      serverUtility: ServerUtility,
      gridSettingsService: GridSettingsService
    ) => {
      return {
        columnDefinitionSet: vsObjectName,
        defaultSort: "PermissionName",
        gridDataSource: new RecordDataSource(serverUtility, "/api/permissions"),
        gridSettings: gridSettingsService.getGridSettings(Symbol(vsObjectName)),
        nameSingular: "Permission",
        namePlural: "Permissions",
      };
    },
  ]);
}
